import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import EuGrants from "@/pages/EuGrants";

export const Route = createFileRoute("/en/eu-grants")({
  head: () => buildRouteHead("/en/eu-grants"),
  component: EuGrants,
});

